import React from 'react'
import { Button } from 'syngenta-react-components'
import { Modal } from 'syngenta-react-components'
import clear from '../../../assets/icons/clear.svg'
import warningIcon from '../../../assets/icons/warning.svg'


const Warning = props => {
  const {
    handleDismissWarning,
    warningMessage,
    warningMessage2,
    confirmationButtonText,
    handleSubmit,
    disabledButton,
    children
  } = props

  return (
    <Modal
      autoHeight
      show={true}
      handleClose={handleDismissWarning}
    >
      <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>Confirm delete</p>
          <button className='bdnone m0 bgc-t' onClick={handleDismissWarning}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <img src={warningIcon} alt='warning icon' className='w50 h50' />
        <div className='m20'>{warningMessage}</div>
        {warningMessage2 && <div className='m20'>{warningMessage2}</div>}
        {children && <div className='m20'>{children}</div>}
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='w100% tar'>
          <Button customClassName='mr10' type={warningMessage2 ? 'error' : null} text={confirmationButtonText} clickHandler={handleSubmit} disabled={disabledButton} />
          <Button customClassName='mr10' styleType={warningMessage2 ? null : 'success'} text='Cancel' clickHandler={handleDismissWarning} disabled={disabledButton} />
        </div>
      </div>
    </Modal>
  )
}

export default Warning